/**
 * =============================================================================
 * Project: lajt-online.pl
 * Created Date: 2018-02-26, 10:33:12
 * Author: Sebastian Drzewicki <sebastian.drzewicki@gmail.com>
 * =============================================================================
 * Last Modified: 2018-02-26, 10:35:01
 * Modified By: Sebastian Drzewicki
 * =============================================================================
 * Copyright (c) 2018 Telestrada
 * =============================================================================
 */

export const FILL_FAQ_LIST = 'FILL_FAQ_LIST';



// WEBPACK FOOTER //
// ./src/store/modules/Help/mutation-types.js